import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
    allUserNames: [],
    sharedUserInfoData: [],
    sharedDocList: [],
    userNameCount: 0,
    isFetching: false,
    isUsersNameSuccess: false,
    isSharedUserInfoSucess: false,
    isError: false,
    errorMessage: '',
    checkOwner: '',
    imagePath: '',
};


export const sharedUserInfo = createAsyncThunk(
    '/clerk/collaboratedDoc',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            // const response = await axios.get('/api/clerk/collaboratedDoc/new', { headers: { "Authorization": `Bearer ${tokenStr}` } });
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            let response = await axios({
                url: `/api${userType}/collaboratedDoc/${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            });

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);



export const getUsersNameAsyn = createAsyncThunk(
    '/clerk/collaboratedDoc/userScope?roomId=',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
            let response = await axios({
                url: `/api${userType}/collaboratedDoc/userScope?roomId=${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            });

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (response.status === 201) {
                return data;
            } else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);



export const commonDocumentSlice = createSlice({
    name: 'commonDocument',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearStateData: (state, { payload }) => {
            state.sharedUserInfoData = [];
            state.sharedDocList = [];
            state.isUsersNameSuccess = false;
            state.isFetching = false;
            state.isError = false;
            state.userNameCount = 0;
            state.errorMessage = '';
            state.checkOwner = '';
            state.imagePath = '';
        },
        setUsersNameState: (state, { payload }) => {
            state.isUsersNameSuccess = true;
            state.allUserNames = payload.data.users;
        },
        clearUsersNameState: (state, { payload }) => {
            state.isUsersNameSuccess = false;
            state.allUserNames = [];
        },
        clearOnlyDataSuccess: (state, { payload }) => {
            state.isUsersNameSuccess = false;
        },
    },

    extraReducers: {


        [sharedUserInfo.fulfilled]: (state, { payload }) => {

            state.sharedUserInfoData = payload.data;
            state.checkOwner = payload.data.data.owner;
            state.sharedDocList = payload.data.fullName;
            state.imagePath = payload.data.imagePath;
            state.isFetching = false;
            state.isSharedUserInfoSucess = true;
            return state;
        },
        [sharedUserInfo.pending]: (state) => {
            state.isFetching = true;
        },
        [sharedUserInfo.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },



        [getUsersNameAsyn.fulfilled]: (state, { payload }) => {

            state.allUserNames = payload.data.data.data;
            state.userNameCount = payload.data.data.metadata[0].total;
            state.isFetching = false;
            state.isUsersNameSuccess = true;
            return state;
        },
        [getUsersNameAsyn.pending]: (state) => {
            state.isFetching = true;
        },
        [getUsersNameAsyn.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },


    },
});


// export const getUsersNameAsyn = (bdata) => async (dispatch, getState) => {
//     const { auth } = getState()
//     let tokenStr = auth.user.token;
//     // const response = await axios.get('/api/clerk/collaboratedDoc/userScope?roomId=', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });
//     let response = await axios({
//         url: `/api/clerk/collaboratedDoc/userScope?roomId=${bdata}`,
//         method: 'get',
//         headers: {
//             "Authorization": `Bearer ${tokenStr}`
//         }
//     });
//     let data = response.data;
//     dispatch(setUsersNameState(data));
//     return data;
// };


export const changeUserStatusInDoc = (dataObj) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
    const response = await axios.patch(`/api${userType}/collaboratedDoc/removeUser`, dataObj, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    // console.log(data)
    //dispatch(setBranchStatus(data));
};


export const ShareDocWithUsersAsyn = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
    const response = await axios.patch(`/api${userType}/collaboratedDoc/addUsers`, bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    //console.log(data.data)
    return data;
};

export const saveDraftName = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
    const response = await axios.patch(`/api${userType}/collaboratedDoc/`, bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    // console.log('save drafts ', data.data)
    return data;
};

export const { clearStateData, setUsersNameState, clearUsersNameState, clearOnlyDataSuccess } = commonDocumentSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateData());
    }
}

export function clearAllUsersNameState() {

    return async (dispatch) => {
        dispatch(clearUsersNameState());
    }
}

export function clearStateclearOnlyDataSuccess() {

    return async (dispatch) => {
        dispatch(clearOnlyDataSuccess());
    }
}

export const commonDocumentSelector = (state) => state.commonDocument;

export default commonDocumentSlice.reducer;
